import React from "react"

export default function Admin() {

    const localUser = JSON.parse(localStorage.getItem("user"));
    if (!localUser.admin && localUser.admin_access < 1) {
        window.location.href = '/';; // Redirection vers la page d'accueil si l'utilisateur n'est pas admin
    }

    return (
        <>
        <div className="flex mt-8">
            <div className="welcome-container flex-grow">
                <h1 className="text-center welcome-title mt-4 text-2xl font-bold">
                    Bienvenue dans la page d'administration
                </h1>
                <p className="text-center welcome-message">
                    Vous pouvez gérer les utilisateurs, les abonnements, les articles, les options, les notifications et les tutoriels ici.
                </p>
            </div>
        </div>
        </> 
    )
}
